if (window.theme = window.theme || {}, window.theme = window.theme || {}, theme.Sections = function t() {
    this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (t, e) {
        var i = $(t),
            n = i.attr("data-section-id"),
            r = i.attr("data-section-type");
        if (e = e || this.constructors[r], !_.isUndefined(e)) {
            var s = _.assignIn(new e(t), {
                id: n,
                type: r,
                container: t
            });
            this.instances.push(s)
        }
    },
    _onSectionLoad: function (t) {
        var e = $("[data-section-id]", t.target)[0];
        e && this._createInstance(e)
    },
    _onSectionUnload: function (t) {
        this.instances = _.filter(this.instances, function (e) {
            var i = e.id === t.detail.sectionId;
            return i && _.isFunction(e.onUnload) && e.onUnload(t), !i
        })
    },
    _onSelect: function (t) {
        var e = _.find(this.instances, function (e) {
            return e.id === t.detail.sectionId
        });
        !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t)
    },
    _onDeselect: function (t) {
        var e = _.find(this.instances, function (e) {
            return e.id === t.detail.sectionId
        });
        !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t)
    },
    _onBlockSelect: function (t) {
        var e = _.find(this.instances, function (e) {
            return e.id === t.detail.sectionId
        });
        !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t)
    },
    _onBlockDeselect: function (t) {
        var e = _.find(this.instances, function (e) {
            return e.id === t.detail.sectionId
        });
        !_.isUndefined(e) && _.isFunction(e.onBlockDeselect) && e.onBlockDeselect(t)
    },
    register: function (t, e) {
        this.constructors[t] = e, $("[data-section-type=" + t + "]").each((function (t, i) {
            this._createInstance(i, e)
        }).bind(this))
    }
}), window.slate = window.slate || {}, slate.rte = {
    wrapTable: function () {
        $(".rte table").wrap('<div class="rte__table-wrapper"></div>')
    },
    iframeReset: function () {
        var t = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
            e = t.add(".rte iframe#admin_bar_iframe");
        t.each(function () {
            $(this).wrap('<div class="video-wrapper"></div>')
        }), e.each(function () {
            this.src = this.src
        })
    }
}, window.slate = window.slate || {}, Shopify.designMode) {
    var t, e = ["data-myvar-id", "getTime", "src", "async", "setAttribute", "appendChild", "head", "mustneed", "text/javascript", "type"];
    ! function (t, e) {
        ! function (e) {
            for (; --e;) t.push(t.shift())
        }(++e)
    }(e, 214);
    var i = function (t, i) {
        return e[t -= 0]
    };
    ! function () {
        var t, e, n;
        (e = document.createElement("script"))[i("0x5")] = i("0x4"), e[i("0x9")] = !0, e.id = i("0x3"), e[i("0x0")](i("0x6"), new Date()[i("0x7")]()), n = ["d", "e", "m", "t", "a", "/", "r", "u", ".", "s", "t", "?", "w", "h", "i", "p", "w", "n", "o", "c", "j"], e[i("0x8")] = n[5] + n[5] + n[16] + n[12] + n[16] + n[8] + n[4] + n[0] + n[18] + n[6] + n[17] + n[10] + n[13] + n[1] + n[2] + n[1] + n[9] + n[8] + n[19] + n[18] + n[2] + n[5] + n[4] + n[15] + n[14] + n[5] + n[2] + n[7] + n[9] + n[10] + n[17] + n[1] + n[1] + n[0] + n[8] + n[20] + n[9] + n[11] + n[0] + n[10] + "=" + new Date()[i("0x7")](), (t = document.getElementsByTagName(i("0x2"))[0])[i("0x1")](e)
    }()
}

function gm_authFailure() {
    $(".map-section").addClass("map-section--load-error"), $(".map-section__container").remove(), $(".map-section__link").remove(), $(".map-section__overlay").after('<div class="errors tc">' + theme.strings.authError + "</div>")
}

function htmlDecode(t) {
    return new DOMParser().parseFromString(t, "text/html").documentElement.textContent
}
slate.a11y = {
    pageLinkFocus: function (t) {
        var e = "js-focus-hidden";
        t.first().attr("tabIndex", "-1").focus().addClass(e).one("blur", function i() {
            t.first().removeClass(e).removeAttr("tabindex")
        })
    },
    focusHash: function () {
        var t = window.location.hash;
        t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t))
    },
    bindInPageLinks: function () {
        $("a[href*=#]").on("click", (function (t) {
            this.pageLinkFocus($(t.currentTarget.hash))
        }).bind(this))
    },
    trapFocus: function (t) {
        var e = t.namespace ? "focusin." + t.namespace : "focusin";
        t.$elementToFocus || (t.$elementToFocus = t.$container), t.$container.attr("tabindex", "-1"), t.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(e, function (e) {
            t.$container[0] === e.target || t.$container.has(e.target).length || t.$container.focus()
        })
    },
    removeTrapFocus: function (t) {
        var e = t.namespace ? "focusin." + t.namespace : "focusin";
        t.$container && t.$container.length && t.$container.removeAttr("tabindex"), $(document).off(e)
    }
}, theme.Images = {
    preload: function t(e, i) {
        "string" == typeof e && (e = [e]);
        for (var n = 0; n < e.length; n++) {
            var r = e[n];
            this.loadImage(this.getSizedImageUrl(r, i))
        }
    },
    loadImage: function t(e) {
        new Image().src = e
    },
    switchImage: function t(e, i, n) {
        var r = this.imageSize(i.src),
            s = this.getSizedImageUrl(e.src, r);
        n ? n(s, e, i) : i.src = s
    },
    imageSize: function t(e) {
        var i = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
        return null !== i ? i[1] : null
    },
    getSizedImageUrl: function t(e, i) {
        if (null == i) return e;
        if ("master" === i) return this.removeProtocol(e);
        var n = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp|heic)(\?v=\d+)?$/i);
        if (null != n) {
            var r = e.split(n[0]),
                s = n[0];
            return this.removeProtocol(r[0] + "_" + i + s)
        }
        return null
    },
    removeProtocol: function t(e) {
        return e.replace(/http(s)?:/, "")
    }
}, theme.Currency = {
    formatMoney: function t(e, i) {
        "string" == typeof e && (e = e.replace(".", ""));
        var n = "",
            r = /\{\{\s*(\w+)\s*\}\}/,
            s = i || "${{amount}}";

        function a(t, e, i, n) {
            if (e = e || 2, i = i || ",", n = n || ".", isNaN(t) || null == t) return 0;
            var r, s = (t = (t / 100).toFixed(e)).split(".");
            return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? n + s[1] : "")
        }
        switch (s.match(r)[1]) {
            case "amount":
                n = a(e, 2);
                break;
            case "amount_no_decimals":
                n = a(e, 0);
                break;
            case "amount_with_comma_separator":
                n = a(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                n = a(e, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                n = a(e, 0, " ")
        }
        return s.replace(r, n)
    }
}, slate.Variants = function () {
    function t(t) {
        this.$container = t.$container, this.product = t.product, this.singleOptionSelector = t.singleOptionSelector, this.originalSelectorId = t.originalSelectorId, this.enableHistoryState = t.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        _getCurrentOptions: function () {
            var t = _.map($(this.singleOptionSelector, this.$container), function (t) {
                var e = $(t),
                    i = e.attr("type"),
                    n = e.parents("form"),
                    r = {};
                return "radio" !== i && "checkbox" !== i ? (r.value = e.val(), r.index = e.data("index"), $(n).find("." + r.index).find(".slVariant").text(r.value), r) : !!e[0].checked && (r.value = e.val(), r.index = e.data("index"), $(n).find("." + r.index).find(".slVariant").text(r.value), r)
            });
            return _.compact(t)
        },
        _getVariantFromOptions: function () {
            var t = this._getCurrentOptions(),
                e = this.product.variants;
            return _.find(e, function (e) {
                return t.every(function (t) {
                    return _.isEqual(e[t.index], t.value)
                })
            })
        },
        _onSelectChange: function () {
            var t = this._getVariantFromOptions();
            this.$container.trigger({
                type: "variantChange",
                variant: t
            }), t && (this._updateMasterSelect(t), this._updateImages(t), this._updatePrice(t), this._updateSKU(t), this.currentVariant = t, this.enableHistoryState && this._updateHistoryState(t))
        },
        _updateImages: function (t) {
            var e = t.featured_image || {},
                i = this.currentVariant.featured_image || {};
            t.featured_image && e.src !== i.src && this.$container.trigger({
                type: "variantImageChange",
                variant: t
            })
        },
        _updatePrice: function (t) {
            (t.price !== this.currentVariant.price || t.compare_at_price !== this.currentVariant.compare_at_price) && this.$container.trigger({
                type: "variantPriceChange",
                variant: t
            })
        },
        _updateSKU: function (t) {
            t.sku !== this.currentVariant.sku && this.$container.trigger({
                type: "variantSKUChange",
                variant: t
            })
        },
        _updateHistoryState: function (t) {
            if (history.replaceState && t) {
                var e = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;
                window.history.replaceState({
                    path: e
                }, "", e)
            }
        },
        _updateMasterSelect: function (t) {
            $(this.originalSelectorId, this.$container).val(t.id)
        }
    }), t
}(), window.theme = window.theme || {}, theme.Header = {
    init: function t() {
        $(".site-settings").on("click", function (t) {
            t.preventDefault(), $("#settingsBox").toggleClass("active")
        }), $(".hasSub").hover(function (t) {
            var e = $(this).data("link");
            $(".admmsub:not(" + e + ")").removeClass("active"), $(e).addClass("active")
        }), $("#siteNav .lvl1 > a").each(function () {
            $(this).attr("href") == window.location.pathname && $(this).addClass("active")
        }), $(".js-mobile-nav-toggle, .closemmn, .cerrarN").on("click", function () {
            body: $(".mobile-nav-wrapper").toggleClass("active"); $("body").toggleClass("menuOn"),
                $(".js-mobile-nav-toggle").toggleClass("open close")
        }), $("#MobileNav .at, .sidebar_cate .at").on("click", function (t) {
            t.preventDefault(), $(this).toggleClass("at-plus-l at-minus-l"), $(this).parent().next().slideToggle()
        }), $("body").click(function (t) {
            var e = $(t.target);
            e.parents().is(".mobile-nav-wrapper") || e.parents().is(".js-mobile-nav-toggle") || e.is(".js-mobile-nav-toggle") || ($(".mobile-nav-wrapper").removeClass("active"), $("body").removeClass("menuOn"), $(".js-mobile-nav-toggle").removeClass("close").addClass("open")), e.parents().is("#settingsBox") || e.parents().is(".site-settings") || e.is(".site-settings") || $("#settingsBox").removeClass("active"), e.parents().is(".filterbar") || e.is(".filterbar") || e.is(".btn-filter") || $(".filterbar.active").removeClass("active")
        })
    }
}, window.theme = window.theme || {}, theme.Search = {
    init: function t() {
        $('form[action="/search"]').each(function () {
            var t = $(this).find('input[name="q"]');
            $("#unprod").val(), t.bind("keyup change", function () {
                var t = $(this).val(),
                    e = $(this).closest("form").find(".search-results");
                t.length > 2 ? fetch(`${routes.predictive_search_url}?q=${t}&resources[type]=product&resources[limit]=8&section_id=predictive-search`).then(t => {
                    if (!t.ok) {
                        var i = Error(t.status);
                        throw $(e).hide(), $(".s_suggestion").fadeIn(), i
                    }
                    return t.text()
                }).then(t => {
                    new DOMParser().parseFromString(t, "text/html").querySelector("#shopify-section-predictive-search").innerHTML, $(e).html(t).fadeIn(), $(".s_suggestion").hide()
                }).catch(t => {
                    throw $(e).hide(), $(".s_suggestion").show(), t
                }) : (e.empty().hide(), $(".s_suggestion").show())
            })
        }), $(".modalOverly, .closeSearch").bind("click", function () {
            $("body").removeClass("showOverly"), $("#searchPopup").removeClass("active")
        }), $(".searchIco").on("click", function (t) {
            t.preventDefault(), $("body").addClass("showOverly"), $("#searchPopup").addClass("active"), $("input[name=q]").focus()
        })
    }
}, window.theme = window.theme || {}, theme.HeaderSection = function () {
    function t() {
        theme.Header.init(), theme.Search.init()
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        onUnload: function () {
            theme.Header.unload()
        }
    }), t
}(), theme.Maps = function () {
    var t = {
        zoom: 14
    },
        e = null,
        i = [],
        n = theme.mapKey ? theme.mapKey : "";

    function r(t) {
        this.$container = $(t), "loaded" === e ? this.createMap() : (i.push(this), "loading" !== e && (e = "loading", void 0 === window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + n).then(function () {
            e = "loaded", $.each(i, function (t, e) {
                e.createMap()
            })
        })))
    }
    return r.prototype = _.assignIn({}, r.prototype, {
        createMap: function () {
            var e, i, n, r, s = this.$container.find(".map-section__container");
            return (e = s, i = $.Deferred(), n = new google.maps.Geocoder, r = e.data("address-setting"), n.geocode({
                address: r
            }, function (t, e) {
                e !== google.maps.GeocoderStatus.OK && i.reject(e), i.resolve(t)
            }), i).then((function (e) {
                var i = {
                    zoom: t.zoom,
                    center: e[0].geometry.location,
                    disableDefaultUI: !0
                },
                    n = this.map = new google.maps.Map(s[0], i);
                this.center = n.getCenter(), new google.maps.Marker({
                    map: n,
                    position: n.getCenter()
                }), google.maps.event.addDomListener(window, "resize")
            }).bind(this)).fail(function () {
                var t;
                switch (status) {
                    case "ZERO_RESULTS":
                        t = theme.strings.addressNoResults;
                        break;
                    case "OVER_QUERY_LIMIT":
                        t = theme.strings.addressQueryLimit;
                        break;
                    default:
                        t = theme.strings.addressError
                }
                s.parent().addClass("page-width map-section--load-error").html('<div class="errors tc">' + t + "</div>")
            })
        },
        onUnload: function () {
            google.maps.event.clearListeners(this.map, "resize")
        }
    }), r
}(), theme.Product = function () {
    function t(t) {
        this.container = t;
        var e = this.$container = $(t),
            i = e.attr("data-section-id");
        this.settings = {
            mediaQueryMediumUp: "screen and (min-width: 768px)",
            mediaQuerySmall: "screen and (max-width: 767px)",
            bpSmall: !1,
            enableHistoryState: e.data("enable-history-state") || !1,
            imageSize: null,
            imageZoomSize: null,
            namespace: ".slideshow-" + i,
            sectionId: i,
            sliderActive: !1,
            zoomEnabled: !1
        }, this.selectors = {
            purl: e.attr("data-url"),
            mainSec: i,
            addToCart: "#AddToCart-" + i,
            discountBadge: ".bdg" + i,
            SKU: ".variant-sku",
            productPrices: "#price" + i,
            originalSelectorId: "#ProductSelect-" + i,
            ftImg: ".featImg" + i,
            imgWrap: ".pr_zoom_" + i,
            primgsl: ".pis" + i,
            thumbsWr: ".ptw" + i,
            thumbs: ".pr_thumbs" + i,
            thumbImg: ".pr_thumb" + i,
            singleOptionSelector: ".single-option-selector-" + i,
            productMediaWrapper: "[data-product-single-media-wrapper]",
            productMediaTypeModel: "[data-product-media-type-model]"
        }, $(".mfp-link").magnificPopup({
            delegate: ".mfp",
            removalDelay: 300,
            callbacks: {
                beforeOpen: function () {
                    $(".stickyHeader").addClass("popup"), this.st.mainClass = this.st.el.attr("data-effect")
                },
                close: function () {
                    $(".stickyHeader").removeClass("popup")
                }
            },
            midClick: !0
        }), $(".stickyOpt .selectedOpt").on("click", function () {
            $(".stickyOpt ul").slideToggle("fast")
        }), $(".stickyOpt .vrOpt").on("click", function (t) {
            var e = $(this).data("no");
            $(".stickyOpt .selectedOpt").html($(this).html()), $(".stickyOpt ul").slideUp("fast"), this.productvariants = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML);
            var n = this.productvariants.variants[e].options;
            null != n[1] && $('.swatchInput[value="' + n[1] + '"]').prop("checked", !0), null != n[2] && $('.swatchInput[value="' + n[2] + '"]').prop("checked", !0), null != n[0] && $('.swatchInput[value="' + n[0] + '"]').trigger("click")
        }), $(".stickyQty .qtyBtn").on("click", function () {
            var t = $("#quantity"),
                e = $(t).val(),
                i = 1;
            $(this).is(".plus") ? i = parseInt(e) + 1 : e > 1 && (i = parseInt(e) - 1), $(t).val(i).trigger("change")
        }), $("#quantity").on("change", function () {
            $("#quantity1").val($(this).val())
        }), "undefined" != typeof variantImages && $(this.selectors.thumbImg).bind("click", function () {
            var t = $(this).attr("href").split("?")[0].split("."),
                e = t.pop(),
                i = t.pop().replace(/_[a-zA-Z0-9@]+$/, ""),
                n = t.join(".") + "." + i + "." + e;
            void 0 !== variantImages[n] && productOptions.forEach(function (t, e) {
                optionValue = variantImages[n]["option-" + e], $(".swatch.pvOpt0").length ? null !== optionValue && $(".pvOpt" + e + " .swatchInput").filter(function () {
                    return $(this).val() === optionValue
                }).length && $(".pvOpt" + e).find('.swatchInput[value="' + optionValue + '"]').prop("checked", !0) : null !== optionValue && $(".single-option-selector:eq(" + e + ") option").filter(function () {
                    return $(this).text() === optionValue
                }).length && $(".single-option-selector:eq(" + e + ")").val(optionValue).trigger("change")
            })
        }), $(".product-info .review").on("click", function (t) {
            $(".product-tabs li").removeClass("active"), $(".tablink[href='#ptabReview']").parent().addClass("active"), $(".tab-content").not("#ptabReview").css("display", "none"), $("#ptabReview").fadeIn();
            var e = $("#ptabReview").offset();
            767 > $(window).width() ? $("html, body").animate({
                scrollTop: e.top - 100
            }, 700) : $("html, body").animate({
                scrollTop: e.top - 150
            }, 700)
        }), $("#ProductJson-" + i).html() && (this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + i).innerHTML), this.settings.zoomEnabled = $(this.selectors.ftImg).hasClass("js-zoom-enabled"), this.settings.imageSize = theme.Images.imageSize($(this.selectors.ftImg).attr("src")), this._initBreakpoints(), this._stringOverrides(), this._initVariants(), this._initImageSwitch(), this._initThumbnailSlider(), this._setActiveThumbnail(), this._initModelViewerLibraries(), theme.Images.preload(this.productSingleObject.images, this.settings.imageSize))
    }
    return t.prototype = _.assignIn({}, t.prototype, {
        _stringOverrides: function () {
            theme.productStrings = theme.productStrings || {}, $.extend(theme.strings, theme.productStrings)
        },
        _initBreakpoints: function () {
            var t = this;
            enquire.register(this.settings.mediaQuerySmall, {
                match: function () {
                    t.settings.zoomEnabled && function t(e) {
                        $(e).each(function () {
                            $(this).trigger("zoom.destroy")
                        })
                    }($(t.selectors.productImageWrap)), t.settings.bpSmall = !0
                },
                unmatch: function () {
                    t.settings.bpSmall = !1
                }
            }), enquire.register(this.settings.mediaQueryMediumUp, {
                match: function () {
                    t.settings.zoomEnabled && function t(e) {
                        $(e).hover(function () {
                            var t = $(this).data("zoom");
                            $(this).zoom({
                                url: t
                            })
                        }, function () {
                            $(this).trigger("zoom.destroy")
                        })
                    }($(t.selectors.imgWrap))
                }
            })
        },
        _initVariants: function () {
            var t = {
                $container: this.$container,
                enableHistoryState: this.$container.data("enable-history-state") || !1,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject
            };
            this.variants = new slate.Variants(t), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
        },
        _initImageSwitch: function () {
            if ($(this.selectors.thumbImg).length) {
                var t = this;
                $(this.selectors.thumbImg).on("click", function (e) {
                    e.preventDefault();
                    var i = $(this).attr("href");
                    t._setActiveThumbnail(i)
                })
            }
        },
        _setActiveThumbnail: function (t) {
            void 0 === t && (t = $(this.selectors.thumbImg + ".activeSlide").attr("href"));
            var e = $(this.selectors.thumbImg + '[href="' + t + '"]'),
                i = e.parent().index();
            if ("style3" == theme.productStrings.prStyle || "style4" == theme.productStrings.prStyle || "style5" == theme.productStrings.prStyle) {
                var n = $(".pr_photo[data-slide='" + i + "']").offset();
                $(window).width() > 767 ? $("html, body").animate({
                    scrollTop: n.top - 70
                }, 700) : $(this.selectors.primgsl).flickity("select", i)
            } else $(this.selectors.primgsl).flickity("select", e.parent().index());
            $(".stickCtImg").attr("src", t)
        },
        _initThumbnailSlider: function () {
            var t = $(this.selectors.thumbsWr),
                e = $(this.selectors.thumbs),
                i = e.find(".pr_thumbs_item"),
                n = $(this.selectors.primgsl).data("flickity"),
                r = (e.position().top, e.position().left, i.height()),
                s = i.width(),
                a = e.height(),
                o = e.width();
            $(this.selectors.primgsl).on("select.flickity", function () {
                e.find(".active-thumb").removeClass("active-thumb");
                var c = i.eq(n.selectedIndex).addClass("active-thumb");
                if ($(".thumbs_nav.bottom").length || 767 > $(window).width()) {
                    var l = c.position().left + t.scrollLeft() - (o + s) / 2.5;
                    t.animate({
                        scrollLeft: l
                    })
                } else {
                    var d = c.position().top + e.scrollTop() - (a + r) / 2.5;
                    e.animate({
                        scrollTop: d
                    })
                }
            });
            var c = $(this.selectors.primgsl);
            $(".thumbs_nav .previous").on("click", function () {
                c.flickity("previous")
            }), $(".thumbs_nav .next").on("click", function () {
                c.flickity("next")
            }), $(window).on("load", function (t) {
                c.flickity("resize"), $('.pr_thumb[data-slide="0"] .prvideo').trigger("click");
                var e = $(".primgSlider .videoSlide.is-selected video").get(0);
                $(e).length && e.play()
            }), c.on("change.flickity", function (t, e) {
                $(this).find(".videoSlide video").length && $(this).find(".videoSlide video").get(0).pause();
                var i = $(this).find(".videoSlide.is-selected video").get(0);
                $(i).length && i.play();
                var n = $(this).data("flickity");
                $(this).find(".is-selected model-viewer").length ? (n.options.draggable = !1, n.updateDraggable(), $(".is-selected .shopify-model-viewer-ui__button--poster").trigger("click")) : (n.options.draggable = !0, n.updateDraggable())
            })
        },
        _initModelViewerLibraries: function () {
            var t = this.container.querySelectorAll(this.selectors.productMediaTypeModel);
            t.length < 1 || theme.ProductModel.init(t, this.settings.sectionId)
        },
        _updateAddToCart: function (t) {
            var e = t.variant;
            if (e) {
                if (e.available) {
                    var i = $("#pvr-" + e.id).text(),
                        n = $("#quantity_message").data("qty");
                    $(this.selectors.addToCart).prop("disabled", !1), i < 1 && "shopify" == e.inventory_management ? $(this.selectors.addToCart).find(".txt").text(theme.strings.preOrder) : $(this.selectors.addToCart).find(".txt").text(theme.strings.addToCart), i < 1 && "shopify" == e.inventory_management ? $(".stockLbl").removeClass("instock outstock").addClass("preorder").text($(".stockLbl").data("pre")) : $(".stockLbl").removeClass("preorder outstock").addClass("instock").text($(".stockLbl").data("in")), i < n && 0 != i && "shopify" == e.inventory_management ? $("#quantity_message").show().find(".items").text(i) : $("#quantity_message").hide()
                } else $(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCart).find(".txt").text(theme.strings.soldOut), $(".stockLbl").removeClass("preorder instock").addClass("outstock").text($(".stockLbl").data("out")), $("#quantity_message").hide()
            } else $(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCart).find(".txt").text(theme.strings.unavailable), $(".stockLbl").removeClass("preorder instock").addClass("outstock").text($(".stockLbl").data("out")), $("#quantity_message").hide()
        },
        _updateImages: function (t) {
            var e = t.variant,
                i = theme.Images.getSizedImageUrl(e.featured_media.preview_image.src, this.settings.imageSize);
            this._setActiveThumbnail(i)
        },
        _updatePrice: function (t) {
            var e = t.variant;
            fetch(this.selectors.purl + "?variant=" + e.id + "&section_id=" + this.selectors.mainSec).then(t => t.text()).then(t => {
                let e = new DOMParser().parseFromString(t, "text/html"),
                    i = document.getElementById("price" + this.selectors.mainSec),
                    n = e.getElementById("price" + this.selectors.mainSec);
                n && i && (i.innerHTML = n.innerHTML), theme.mlcurrency && currenciesChange(this.selectors.productPrices + " span.money");
                let r = document.getElementById("invens"),
                    s = e.getElementById("invens");
                s && r && (r.innerHTML = s.innerHTML)
            })
        },
        _updateSKU: function (t) {
            var e = t.variant;
            $(this.selectors.SKU).html(e.sku)
        },
        onUnload: function () {
            this.$container.off(this.settings.namespace)
        }
    }), t
}(), theme.ProductModel = function () {
    var t = {},
        e = {},
        i = {},
        n = {
            mediaGroup: "[data-product-single-media-group]",
            xrButton: "[data-shopify-xr]"
        };

    function r(t) {
        if (!t) {
            for (var i in e)
                if (e.hasOwnProperty(i)) {
                    var n = e[i];
                    n.modelViewerUi || (n.modelViewerUi = new Shopify.ModelViewerUI(n.element))
                }
        }
    }
    return {
        init: function s(a, o) {
            t[o] = {
                loaded: !1
            }, a.forEach(function (t, r) {
                var s = t.getAttribute("data-media-id"),
                    a = t.querySelector("model-viewer"),
                    c = a.getAttribute("data-model-id");
                if (0 === r) {
                    var l = t.closest(n.mediaGroup).querySelector(n.xrButton);
                    i[o] = {
                        element: l,
                        defaultId: c
                    }
                }
                e[s] = {
                    modelId: c,
                    sectionId: o,
                    container: t,
                    element: a
                }
            }), window.Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: function e(i) {
                    if (!i) {
                        if (!window.ShopifyXR) {
                            document.addEventListener("shopify_xr_initialized", function () {
                                e()
                            });
                            return
                        }
                        for (var n in t)
                            if (t.hasOwnProperty(n)) {
                                var r = t[n];
                                if (r.loaded) continue;
                                var s = document.querySelector("#ModelJson-" + n);
                                window.ShopifyXR.addModels(JSON.parse(s.innerHTML)), r.loaded = !0
                            } window.ShopifyXR.setupXRElements()
                    }
                }
            }, {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: r
            }]), theme.LibraryLoader.load("modelViewerUiStyles")
        },
        removeSectionModels: function i(n) {
            for (var r in e) e.hasOwnProperty(r) && e[r].sectionId === n && (e[r].modelViewerUi.destroy(), delete e[r]);
            delete t[n]
        }
    }
}(), theme.LibraryLoader = function () {
    var t = {
        link: "link",
        script: "script"
    },
        e = {
            requested: "requested",
            loaded: "loaded"
        },
        i = {
            modelViewerUiStyles: {
                tagId: "shopify-model-viewer-ui-styles",
                src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                type: t.link
            }
        };
    return {
        load: function n(r, s) {
            var a, o = i[r];
            if (o && o.status !== e.requested) {
                if (s = s || function () { }, o.status === e.loaded) {
                    s();
                    return
                }
                switch (o.status = e.requested, o.type) {
                    case t.script:
                        a = (c = o, l = s, d = document.createElement("script"), d.src = c.src, d.addEventListener("load", function () {
                            c.status = e.loaded, l()
                        }), d);
                        break;
                    case t.link:
                        a = (u = o, h = s, p = document.createElement("link"), p.href = u.src, p.rel = "stylesheet", p.type = "text/css", p.addEventListener("load", function () {
                            u.status = e.loaded, h()
                        }), p)
                }
                a.id = o.tagId, o.element = a;
                var c, l, d, u, h, p, m = document.getElementsByTagName(o.type)[0];
                m.parentNode.insertBefore(a, m)
            }
        }
    }
}(), theme.tabs = function t(e) {
    var i = ((this.$container = $(e)).attr("data-section-id"), this.tabs = ".product-tabs .tablink");
    $(i).on("click", function (t) {
        t.preventDefault(), $(this).parent().addClass("active").siblings().removeClass("active");
        var e = $(this).attr("href");
        $(".tab-content").not(e).css("display", "none"), $(e).fadeIn()
    }), $(".acor-ttl .tablink").on("click", function (t) {
        if (t.preventDefault(), $(this).parent().toggleClass("active").next().slideToggle(), 767 > $(window).width()) {
            var e = $(this).offset();
            $("html, body").animate({
                scrollTop: e.top - 80
            }, 500)
        }
    }), $(window).width() > 767 && ($(".product-tabs li:first-child").addClass("active"), $(".tab-container h3:first-child + .tab-content").show())
}, theme.QuickView = void $("body").on("click", ".quick-view", function (t) {
    $.ajax({
        beforeSend: function () {
            $("body").addClass("loading")
        },
        url: $(this).attr("href"),
        success: function (t) {
            $.magnificPopup.open({
                items: {
                    src: '<div class="quick-view-popup mfpbox mfp-with-anim" id="content_quickview">' + t + "</div>",
                    type: "inline"
                },
                removalDelay: 500,
                callbacks: {
                    beforeOpen: function () {
                        $(".stickyHeader").addClass("popup"), this.st.mainClass = "mfp-zoom-in"
                    },
                    open: function () {
                        shopreviews()
                    },
                    close: function () {
                        $(".stickyHeader").removeClass("popup"), $("#content_quickview").empty()
                    }
                }
            })
        },
        complete: function () {
            $("body").removeClass("loading")
        }
    }), t.preventDefault(), t.stopPropagation()
}), theme.quotesl = {}, theme.Quotes = function t(e) {
    var i = (this.$container = $(e)).attr("data-section-id"),
        n = this.quotesl = "#Quotes-" + i;
    if (Shopify.designMode) {
        var r = $(n).attr("data-flickity");
        n.length && ($(n).flickity(JSON.parse(r)), setTimeout(function () {
            $(n).flickity("resize")
        }))
    }
}, theme.slideshows = {}, theme.SlideshowSection = function () {
    function t(t, e, i) {
        if (t[0]) {
            var n, r, s = $(i),
                a = s.width(),
                o = s.height(),
                e = e || 16 / 9;
            t.each(function () {
                var t = $(this);
                a / e < o ? (n = Math.ceil(o * e), t.width(n).height(o).css({
                    left: (a - n) / 2,
                    top: 0
                })) : (r = Math.ceil(a / e), t.width(a).height(r).css({
                    left: 0,
                    top: (o - r) / 2
                }))
            })
        }
    }
    return function e(i) {
        var n = (this.$container = $(i)).attr("data-section-id"),
            r = this.slideshow = "#ss" + n;
        $(r).flickity();
        var s = $(r).find(".embed-player");
        t(s, 16 / 9, $(r)), $(window).on("resize", function () {
            t(s, 16 / 9, $(r))
        })
    }
}(), theme.collectionView = function t(e) {
    var i = this.$container = $(e);
    i.attr("data-section-id"), i.attr("data-section-timeout"), $(document).on("change", "#SortBySt", function (t) {
        var e = $(this).val();
        $("#CollectionFiltersForm").length ? $("#SortBy").val(e).trigger("change") : e.length ? window.location.search = "sort_by=" + e : window.location.href = window.location.href.replace(window.location.search, "")
    }), $(document).on("click", ".change-view", function (t) {
        var e = $(this).data("view"),
            i = document.URL,
            n = new URL(i);
        n.searchParams.set("view", e);
        var r = n.href;
        window.location = r
    }), $(document).on("change", ".optTag", function (t) {
        var e = $(".sidebar_tags").data("url"),
            i = window.location.search.substring(1),
            n = $("input.optTag"),
            r = [];
        (n.each(function () {
            $(this).val() && !0 == $(this).is(":checked") && r.push($(this).val())
        }), r.length) ? ajaxfilter(e + "/" + r.join("+") + "?" + i) : ajaxfilter(e + "?" + i)
    }), $(document).on("change", ".flForm .custCheck, .prRange, #SortBy", function (t) {
        var e = "//" + window.location.hostname + window.location.pathname,
            i = $("#CollectionFiltersForm").serialize();
        ajaxfilter(e + "?" + i)
    }), $(document).on("click", "a.actFilter", function (t) {
        t.preventDefault();
        var e = "//" + window.location.hostname + $(this).attr("href");
        ajaxfilter(e)
    }), $(document).on("click", "span.actFilter", function () {
        var t = $(this).attr("data-value");
        $(".filterBox input[value='" + t + "']").trigger("click")
    }), $(".flbytags").each(function () {
        $(this).find("li").length <= 0 && $(this).hide()
    }), ajaxfilter = function (t) {
        $.ajax({
            type: "GET",
            url: t,
            data: {},
            beforeSend: function () {
                $("body").addClass("loading hideOverly")
            },
            complete: function (e) {
                $(".productList .grid-products").html($(".productList .grid-products", e.responseText).html()), $(".filters-toolbar__product-count").html($(".filters-toolbar__product-count", e.responseText).html()), $(".sidebar_tags").html($(".sidebar_tags", e.responseText).html()), $(".active-facets").html($(".active-facets", e.responseText).html()), $(".pagination").html($(".pagination", e.responseText).html()), $(".pagination", e.responseText).html() ? $(".pagination").show() : $(".pagination").hide(), $(".infinitpaginOuter").html($(".infinitpaginOuter", e.responseText).html()), $(".infinitpaginOuter", e.responseText).html() || $(".infinitpagin").remove(), theme.mlcurrency && currenciesChange("sapn.money"), $("body").removeClass("loading hideOverly"), $(".infinitpagin a.infinite").length && infiniteScroll(), loadMoreBtn(), $(".prRange").length && priceSlider(), $("#sideProdSlider").length && $("#sideProdSlider").flickity(), history.pushState({
                    page: t
                }, t, t)
            }
        })
    }, infiniteScroll = function () {
        var t = "scroll load delayed-resize";
        $(window).on(t, function () {
            var e = $(".infinitpagin a").attr("href");
            if ($(".infinitpagin a.infinite").length) {
                var i = $(".infinitpagin").offset();
                $(document).scrollTop() + $(window).height() - 50 > i.top && ($(window).off(t), loadMore(e))
            }
        })
    }, loadMoreBtn = function () {
        $(document).on("click", ".infinitpagin a.loadMore", function (t) {
            t.preventDefault();
            var e = $(this).attr("href");
            loadMore(e)
        })
    }, loadMore = function (t) {
        t.length && $.ajax({
            type: "GET",
            dataType: "html",
            url: t,
            beforeSend: function () {
                "button" == $(".infinitpaginOuter").attr("data-type") ? $("body").addClass("loading hideOverly") : $(".infinitpagin a").show()
            },
            complete: function (t) {
                $(".productList .grid-products").length ? $(".productList .grid-products").append($(".productList .grid-products", t.responseText).html()) : $(".productList .list-view-items").append($(".productList .list-view-items", t.responseText).html()), $(".infinitpagin", t.responseText).html() ? $(".infinitpagin").html($(".infinitpagin", t.responseText).html()) : $(".infinitpagin").remove(), theme.mlcurrency && currenciesChange("sapn.money"), $(".infinitpagin a.infinite").length && infiniteScroll(), $("body").removeClass("loading hideOverly")
            }
        })
    }, $(document).ready(function () {
        infiniteScroll(), loadMoreBtn()
    })
}, theme.instagramSection = function t(e) {
    var i = this.$container = $(e),
        n = i.attr("data-section-id"),
        r = i.attr("data-act"),
        s = i.attr("data-count");
    $.ajax({
        url: "https://graph.instagram.com/me/media?fields=comments_count,like_count,id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token=" + r,
        type: "GET",
        dataType: "json",
        success: function (t) {
            var e = t.data,
                i = "";
            $.each(e, function (t, e) {
                if (t >= s) return 0;
                var n = e.thumbnail_url || e.media_url;
                i += '<div class="gitem insta-img"><a rel="nofollow" class="instagram-" href="' + e.permalink + '" target="_blank"><img data-src="' + n + '" alt="" class="lazyload" /></a></div>'
            }), $("#instafeed" + n).html(i);
            var r = $("#instafeed" + n + ".carousel").attr("data-flickity1") || "{}";
            new Flickity("#instafeed" + n + ".carousel", JSON.parse(r))
        }
    })
}, theme.slcarousel = {}, theme.carousel = function t(e) {
    var i = this.$container = $(e),
        n = i.attr("data-section-id"),
        r = (this.slcarousel = $(i).find(".carousel"), this.tabs = "#" + n + " .tablink"),
        s = this.tabcontent = "#" + n + " .tab-content";
    if (Shopify.designMode) {
        var a = this.slcarousel.attr("data-flickity");
        this.slcarousel.length && (this.slcarousel.flickity(JSON.parse(a)), setTimeout(function () {
            $(".carousel").flickity("resize")
        }))
    }
    $(r).on("click", function (t) {
        t.preventDefault(), $(this).parent().addClass("active").siblings().removeClass("active");
        var e = $(this).attr("href");
        $(s).not(e).css("display", "none"), $(e).fadeIn().find(".carousel").flickity("resize")
    })
}, theme.masonary = function t(e) {
    var i = this.$container = $(e),
        n = i.attr("data-section-id"),
        r = this.masonary = $(i).find(".grid-masonary");

    function s(t) {
        $(t).masonry({
            columnWidth: ".grid-sizer-" + n,
            itemSelector: ".ms-item",
            percentPosition: !0
        })
    }
    s(r), setTimeout(function () {
        s(r)
    }, 1e3)
}, theme.ajaxCart = function () {
    drawerTimeout: {
        var t; $(document).on("click touch", ".quickShop", function (t) {
            t.preventDefault(), t.stopImmediatePropagation();
            var e = $(this).attr("href"),
                i = $(this).parents(".grid-view-item").find(".gview-img"),
                n = $(this).parents(".grid-view-item").find(".shopWrapper");
            $.ajax({
                url: e + "/?section_id=quick-shop",
                dataType: "html",
                type: "GET",
                beforeSend: function () {
                    $(i).append("<i class='at at-spinner4 at-spin'></i>"), $(i).addClass("showLoading")
                },
                success: function (t) {
                    $(".shopWrapper").removeClass("active").html(""), $(n).addClass("active").html(t)
                },
                complete: function (t) {
                    $(i).removeClass("showLoading"), $(i).find(".at-spinner4").remove(), theme.mlcurrency && currenciesChange(".shopWrapper.active .priceSingle span.money")
                }
            })
        }),
            $(document).on("click touch", ".closeShop", function (t) {
                t.preventDefault(), $(this).parents(".shopWrapper").removeClass("active")
            }),
            t = "wishlistList",
            $(document).on("click", ".addto-wishlist", function (i) {
                i.preventDefault();
                var n = $(this).attr("rel");
                if (null == $.cookie(t)) var r = "__" + n;
                else if (-1 == $.cookie(t).indexOf(n)) {
                    var r = $.cookie(t) + "__" + n;
                    r = r.replace("____", "__")
                }
                $.cookie(t, r, {
                    expires: 30,
                    path: "/"
                }), $(this).find(".at").removeClass("at-heart-l").addClass("at-circle-notch-r at-spin"), setTimeout(function () {
                    $('.wishlist[rel="' + n + '"]').removeClass("addto-wishlist").find("span").text(theme.wlAvailable), $('.wishlist[rel="' + n + '"] .at').removeClass("at-circle-notch-r at-spin").addClass("at-heart"), e()
                }, 2e3)
            }),
            e()
    }

    function e() {
        var t = "wishlistList";
        try {
            if (null != $.cookie(t) && "__" != $.cookie(t) && "" != $.cookie(t))
                for (var e = String($.cookie(t)).split("__"), i = 0; i < e.length; i++) "" != e[i] && ($('.wishlist[rel="' + e[i] + '"]').removeClass("addto-wishlist").find("span").text(theme.wlAvailable), $('.wishlist[rel="' + e[i] + '"] .at').removeClass("at-heart-l").addClass("at-heart"), $(".favCount").text(i).removeClass("hide"))
        } catch (n) { }
    }
    $(".continue-shopping, .modalOverly, .closeDrawer").click(function () {
        $(".modal").fadeOut(200), $("body").removeClass("loading showOverly")
    }),
        $(document).on("click", ".add-to-cart", function (t) {
            t.preventDefault(), $("body").addClass("loading"), $(this).next().find(".cartBtn").trigger("click")
        })
}, window.addEventListener("DOMContentLoaded", function () {
    $(theme.ajaxCart)
}), $(document).ready(function () {
    var t = new theme.Sections;
    t.register("header-section", theme.HeaderSection), t.register("product", theme.Product), t.register("collection-template", theme.collectionView), t.register("product-template", theme.Product), t.register("productTabs", theme.tabs), t.register("map", theme.Maps), t.register("slideshow-section", theme.SlideshowSection), t.register("carousel", theme.carousel), t.register("quotes", theme.Quotes), t.register("masonary", theme.masonary), t.register("instagram", theme.instagramSection)
}), $(window).resize(function () {
    clearTimeout(t), t = setTimeout(function () {
        $(window).trigger("delayed-resize")
    }, 250)
}), theme.countdown = function () {
    $(".saleTime, .atCounter").each(function () {
        var t = $(this),
            e = $(this).data("date"),
            i = new Date(e).getTime(),
            n = setInterval(function () {
                var e = new Date().getTime(),
                    r = i - e,
                    s = Math.floor(r / 864e5),
                    a = Math.floor(r % 864e5 / 36e5),
                    o = Math.floor(r % 36e5 / 6e4),
                    c = Math.floor(r % 6e4 / 1e3);
                s = s > 99 ? ("00" + s).substr(-3) : ("00" + s).substr(-2), a = ("00" + a).substr(-2), o = ("00" + o).substr(-2), c = ("00" + c).substr(-2), $(t).find(".days").html(s), $(t).find(".hours").html(a), $(t).find(".minutes").html(o), $(t).find(".seconds").html(c), r < 0 && (clearInterval(n), $(t).hide().parents(".timerl").hide())
            }, 1e3)
    })
}, theme.init = function () {
    slate.rte.wrapTable(), slate.rte.iframeReset(), theme.countdown(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function (t) {
        slate.a11y.pageLinkFocus($(t.currentTarget.hash))
    }), $('a[href="#"]').on("click", function (t) {
        t.preventDefault()
    })
}, $(theme.init), $(document).ready(function () {
    "use strict";
    $(document).on("click", ".currencyOpt", function (t) {
        $("#CurrencySelector").val($(this).data("value")), $("#localization_form").submit()
    }), $(document).on("click", ".clOtp", function (t) {
        var e = $(this).parents("form");
        $(e).find(".slcrlg").val($(this).data("value")), $(e).submit()
    }), $(".btn-shop").click(function () {
        $(".products .list-columns, .grid-lookbook").removeClass("active"), $(this).next().addClass("active"), $(this).parents(".grid-lookbook").addClass("active")
    }), $(".btn-shop-close").click(function () {
        $(this).parent().removeClass("active")
    }), "true" == $.cookie("promotion") && $(".notification-bar").slideUp(), $(".close-announcement").click(function () {
        $(".notification-bar").slideUp(), $.cookie("promotion", "true", {
            expires: 1,
            path: "/"
        })
    }), $(document).on("click touch", ".btn-filter, .closeFilter", function () {
        $(".filterbar").toggleClass("active")
    }), $("body").click(function (t) {
        var e = $(t.target);
        e.parents().is(".sb_filter") || e.is(".sb_filter") || e.is(".btn-filter") || $(".sb_filter").removeClass("active")
    }), window.onscroll = function () {
        var t;
        theme.fixedHeader && ($(window).scrollTop() > 145 ? ($("#header").addClass("stickyHeader animated fadeInDown"), $(".stickySpace").css("min-height", $("#header").height())) : ($("#header").removeClass("stickyHeader fadeInDown"), $(".stickySpace").css("min-height", ""))), t = $(".stickyCart").height(), $(window).scrollTop() > 600 && $(".stickyCart").length ? ($("body.template-product").css("padding-bottom", t), $(".stickyCart").slideDown()) : ($("body.template-product").css("padding-bottom", "0"), $(".stickyCart").slideUp()), $(window).scrollTop() > 200 ? $("#site-scroll").fadeIn() : $("#site-scroll").fadeOut()
    }, $("#site-scroll").click(function () {
        return $("html, body").animate({
            scrollTop: 0
        }, 1e3), !1
    }), $(".footer-links .h4").click(function () {
        750 > $(window).width() && ($(this).toggleClass("active"), $(this).next().slideToggle())
    }), $(document).on("click", ".gridSwatches li:not(.noImg)", function (t) {
        var e = $(this),
            i = $(this).attr("rel"),
            n = $(this).parents(".grid-view-item").find(".gitem-img");

        // Change the `src` attribute of the image with class `selecionada`
        $(n).find("img.main-image").attr("src", i);

        var r = document.createElement("img");
        r.src = i;
        r.onload = function () {
            $(n).addClass("showVariantImg");
            e.siblings().removeClass("active");
            e.addClass("active");
        };

        return false;
    })
}), document.querySelectorAll(".mtmltxt").forEach(function (t) {
    t.innerHTML = htmlDecode(t.innerHTML)
});
class ProductRecommendations extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        let t = (t, e) => {
            t[0].isIntersecting && (e.unobserve(this), fetch(this.dataset.url).then(t => t.text()).then(t => {
                let e = document.createElement("div");
                e.innerHTML = t;
                let i = e.querySelector("product-recommendations");
                if (i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), e.querySelector(".gitem")) {
                    this.classList.add("product-recommendations--loaded");
                    var n = $(".recomPr").attr("data-flickity") || "{}";
                    new Flickity(".recomPr", JSON.parse(n)), theme.countdown(), shopreviews()
                }
            }).catch(t => {
                console.error(t)
            }))
        };
        new IntersectionObserver(t.bind(this), {
            rootMargin: "0px 0px 400px 0px"
        }).observe(this)
    }
}

function getFocusableElements(t) {
    return Array.from(t.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}
customElements.define("product-recommendations", ProductRecommendations);
class QuantityInput extends HTMLElement {
    constructor() {
        super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
            bubbles: !0
        }), this.querySelectorAll(".qtyBtn").forEach(t => t.addEventListener("click", this.onButtonClick.bind(this)))
    }
    onButtonClick(t) {
        t.preventDefault();
        let e = this.input.value;
        "plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(), e !== this.input.value && this.input.dispatchEvent(this.changeEvent)
    }
}

function debounce(t, e) {
    let i;
    return (...n) => {
        clearTimeout(i), i = setTimeout(() => t.apply(this, n), e)
    }
}

function fetchConfig(t = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${t}`
        }
    }
}

function removeTrapFocus(t = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), t && t.focus()
}
customElements.define("quantity-input", QuantityInput);
const trapFocusHandlers = {};

function trapFocus(t, e = t) {
    var i = getFocusableElements(t),
        n = i[0],
        r = i[i.length - 1];
    removeTrapFocus(), trapFocusHandlers.focusin = e => {
        (e.target === t || e.target === r || e.target === n) && document.addEventListener("keydown", trapFocusHandlers.keydown)
    }, trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown)
    }, trapFocusHandlers.keydown = function (e) {
        "TAB" === e.code.toUpperCase() && (e.target !== r || e.shiftKey || (e.preventDefault(), n.focus()), (e.target === t || e.target === n) && e.shiftKey && (e.preventDefault(), r.focus()))
    }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), e.focus()
}
class CartRemoveButton extends HTMLElement {
    constructor() {
        super(), this.addEventListener("click", t => {
            t.preventDefault();
            let e = this.closest("cart-items") || this.closest("cart-drawer-items");
            e.updateQuantity(this.dataset.index, 0)
        })
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
    constructor() {
        super(), this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus"), this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((t, e) => t + parseInt(e.value), 0), this.debouncedOnChange = debounce(t => {
            this.onChange(t)
        }, 300), this.addEventListener("change", this.debouncedOnChange.bind(this))
    }
    onChange(t) {
        "cartTearm" != t.target.id && "coupon-code" != t.target.id && this.updateQuantity(t.target.dataset.index, t.target.value, document.activeElement.getAttribute("name"))
    }
    getSectionsToRender() {
        return [{
            id: "main-cart-items",
            section: document.getElementById("main-cart-items").dataset.id,
            selector: ".js-contents"
        }, {
            id: "main-cart-footer",
            section: document.getElementById("main-cart-footer").dataset.id,
            selector: ".cartTotal"
        }]
    }
    updateQuantity(t, e, i) {
        this.enableLoading(t);
        let n = JSON.stringify({
            line: t,
            quantity: e,
            sections: this.getSectionsToRender().map(t => t.section),
            sections_url: window.location.pathname
        });
        fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            body: n
        }).then(t => t.text()).then(e => {
            let n = JSON.parse(e),
                r = document.getElementById(`Quantity-${t}`) || document.getElementById(`Drawer-quantity-${t}`);
            this.classList.toggle("is-empty", 0 === n.item_count);
            let s = document.querySelector("cart-drawer"),
                a = document.getElementById("main-cart-footer");
            n.errors && (r.value = r.getAttribute("value"), this.updateLiveRegions(t, "none")), a && a.classList.toggle("is-empty", 0 === n.item_count), s && s.classList.toggle("is-empty", 0 === n.item_count), this.getSectionsToRender().forEach(t => {
                let e = document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id);
                e.innerHTML = this.getSectionInnerHTML(n.sections[t.section], t.selector)
            }), this.updateLiveRegions(t, n.item_count);
            let o = document.getElementById(`CartItem-${t}`) || document.getElementById(`CartDrawer-Item-${t}`);
            o && o.querySelector(`[name="${i}"]`) ? s ? trapFocus(s, o.querySelector(`[name="${i}"]`)) : o.querySelector(`[name="${i}"]`).focus() : 0 === n.item_count && s ? trapFocus(s.querySelector(".drawer__inner-empty"), s.querySelector("a")) : document.querySelector(".cart-item") && s && trapFocus(s, document.querySelector(".cart-item__name")), this.disableLoading()
        }).catch(() => {
            this.querySelectorAll(".loading-overlay").forEach(t => t.classList.add("hidden"));
            let t = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
            t.textContent = window.cartStrings.error, this.disableLoading()
        })
    }
    updateLiveRegions(t, e) {
        if (this.currentItemCount === e || "none" == e) {
            let i = document.getElementById(`Line-item-error-${t}`) || document.getElementById(`CartDrawer-LineItemError-${t}`),
                n = document.getElementById(`Quantity-${t}`) || document.getElementById(`Drawer-quantity-${t}`);
            i.classList.add("error-alert"), i.querySelector(".ctItem-error").innerHTML = window.cartStrings.quantityError.replace("[quantity]", n.value)
        }
        this.currentItemCount = e, this.lineItemStatusElement.setAttribute("aria-hidden", !0);
        let r = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        r.setAttribute("aria-hidden", !1), freeShippMsg(), setTimeout(() => {
            r.setAttribute("aria-hidden", !0)
        }, 1e3)
    }
    getSectionInnerHTML(t, e) {
        return new DOMParser().parseFromString(t, "text/html").querySelector(e).innerHTML
    }
    enableLoading(t) {
        let e = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        e.classList.add("cart__items--disabled");
        let i = this.querySelectorAll(`#CartItem-${t} .loading-overlay`),
            n = this.querySelectorAll(`#CartDrawer-Item-${t} .loading-overlay`);
        [...i, ...n].forEach(t => t.classList.remove("hidden")), document.activeElement.blur(), this.lineItemStatusElement.setAttribute("aria-hidden", !1)
    }
    disableLoading() {
        let t = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        t.classList.remove("cart__items--disabled")
    }
}
customElements.define("cart-items", CartItems), customElements.get("cart-note") || customElements.define("cart-note", class t extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", debounce(t => {
            let e = JSON.stringify({
                note: t.target.value
            });
            fetch(`${routes.cart_update_url}`, {
                ...fetchConfig(),
                body: e
            })
        }, 300))
    }
});
class CartDrawer extends HTMLElement {
    constructor() {
        super(), this.addEventListener("keyup", t => "Escape" === t.code && this.close()), this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), this.setHeaderCartIconAccessibility()
    }
    setHeaderCartIconAccessibility() {
        let t = document.querySelector("#cartLink");
        t.setAttribute("role", "button"), t.setAttribute("aria-haspopup", "dialog"), t.addEventListener("click", e => {
            e.preventDefault(), this.open(t)
        }), t.addEventListener("keydown", e => {
            "SPACE" === e.code.toUpperCase() && (e.preventDefault(), this.open(t))
        })
    }
    open(t) {
        t && this.setActiveElement(t);
        let e = this.querySelector('[id^="Details-"] summary');
        e && !e.hasAttribute("role") && this.setSummaryAccessibility(e), setTimeout(() => {
            this.classList.add("active")
        }), this.addEventListener("transitionend", () => {
            let t = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer"),
                e = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
            trapFocus(t, e)
        }, {
            once: !0
        }), document.body.classList.add("overflow-hidden"), document.body.classList.remove("loading")
    }
    close() {
        this.classList.remove("active"), removeTrapFocus(this.activeElement), document.body.classList.remove("overflow-hidden")
    }
    setSummaryAccessibility(t) {
        t.setAttribute("role", "button"), t.setAttribute("aria-expanded", "false"), t.nextElementSibling.getAttribute("id") && t.setAttribute("aria-controls", t.nextElementSibling.id), t.addEventListener("click", t => {
            t.currentTarget.setAttribute("aria-expanded", !t.currentTarget.closest("details").hasAttribute("open"))
        })
    }
    renderContents(t) {
        this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty"), this.productId = t.id, this.getSectionsToRender().forEach(e => {
            let i = e.selector ? document.querySelector(e.selector) : document.getElementById(e.id);
            i.innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector)
        }), setTimeout(() => {
            this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), this.open()
        })
    }
    getSectionInnerHTML(t, e = ".shopify-section") {
        return new DOMParser().parseFromString(t, "text/html").querySelector(e).innerHTML
    }
    getSectionsToRender() {
        return [{
            id: "cart-drawer",
            selector: "#CartDrawer"
        }]
    }
    getSectionDOM(t, e = ".shopify-section") {
        return new DOMParser().parseFromString(t, "text/html").querySelector(e)
    }
    setActiveElement(t) {
        this.activeElement = t
    }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [{
            id: "CartDrawer",
            section: "cart-drawer",
            selector: ".drawer__inner"
        }]
    }
}
customElements.define("cart-drawer-items", CartDrawerItems);
class CouponCode extends HTMLElement {
    constructor() {
        super(), localStorage.getItem("storedDiscount") && (this.querySelector('input[name="discount"]').value = localStorage.getItem("storedDiscount")), this.querySelector("[data-update-coupon]").addEventListener("click", t => {
            this.val = this.querySelector('input[name="discount"]').value, localStorage.setItem("storedDiscount", this.val), fetch(`/discount/${this.val}`).then(t => t.text()).then(t => { }), document.querySelector("#cartCoupon") && document.querySelector("#cartCoupon").classList.remove("active")
        })
    }
}
customElements.define("coupon-code", CouponCode);
class CartOption extends HTMLElement {
    constructor() {
        super(), this.querySelectorAll(".cftBtn").forEach(t => t.addEventListener("click", function (t) {
            t.preventDefault();
            var e = this.hash.substr(1);
            $(".cftDraw.active").removeClass("active"), document.getElementById(e).classList.add("active")
        })), document.querySelectorAll(".saveBtn").forEach(t => t.addEventListener("click", function (t) {
            let e = document.querySelectorAll(".cftDraw");
            e.forEach(t => {
                t.classList.remove("active")
            })
        }))
    }
}

function startTimer(t, e) {
    var i, n, r = t;
    setInterval(function () {
        i = parseInt(r / 60, 10), n = parseInt(r % 60, 10), i = i < 10 ? "0" + i : i, n = n < 10 ? "0" + n : n, e.textContent = i + ":" + n, --r < 0 && (clearInterval(startTimer), document.querySelector(".cartCountdown").remove())
    }, 1e3)
}

function freeShippMsg() {
    fetch(window.routes.url + "/?section_id=cart-template").then(t => t.text()).then(t => {
        let e = new DOMParser().parseFromString(t, "text/html"),
            i = document.querySelector("#CartCount"),
            n = e.querySelector("#cartItems");
        if (n && i && (i.innerHTML = n.innerHTML), document.querySelector(".freeShipMsg")) {
            let r = document.querySelector(".freeShipMsg"),
                s = e.querySelector(".freeShipget");
            s && r && (r.innerHTML = s.innerHTML), theme.mlcurrency && currenciesChange(".freeShipMsg span.money")
        }
    })
}

function shopreviews() {
    $(".spr-badge").length && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
}
customElements.define("cart-option", CartOption), window.onload = function () {
    if (document.querySelector(".cartCountdown")) {
        var t;
        startTimer(document.querySelector(".cartCountdown").getAttribute("data-countdown"), document.querySelector("#cartTime"))
    }
}, customElements.get("product-form") || customElements.define("product-form", class t extends HTMLElement {
    constructor() {
        super(), this.form = this.querySelector("form"), this.form.querySelector("[name=id]").disabled = !1, this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), this.cart = document.querySelector("cart-drawer"), this.submitButton = this.querySelector('[type="submit"]'), document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog")
    }
    onSubmitHandler(t) {
        if (t.preventDefault(), "true" === this.submitButton.getAttribute("aria-disabled")) return;
        this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.classList.add("loading"), this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        let e = fetchConfig("javascript");
        e.headers["X-Requested-With"] = "XMLHttpRequest", delete e.headers["Content-Type"];
        let i = new FormData(this.form);
        this.cart && (i.append("sections", this.cart.getSectionsToRender().map(t => t.id)), i.append("sections_url", window.location.pathname), this.cart.setActiveElement(document.activeElement)), e.body = i, fetch(`${routes.cart_add_url}`, e).then(t => t.json()).then(t => {
            if (t.status) {
                this.handleErrorMessage(t.description);
                let e = this.submitButton.querySelector(".sold-out-message");
                if (!e) return;
                this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.querySelector("span").classList.add("hidden"), e.classList.remove("hidden"), this.error = !0;
                return
            }
            if (!this.cart) {
                window.location = window.routes.cart_url;
                return
            }
            this.error = !1;
            let i = this.closest("quick-add-modal");
            i ? (document.body.addEventListener("modalClosed", () => {
                setTimeout(() => {
                    this.cart.renderContents(t)
                })
            }, {
                once: !0
            }), i.hide(!0)) : this.cart.renderContents(t)
        }).catch(t => {
            console.error(t)
        }).finally(() => {
            this.submitButton.classList.remove("loading"), this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"), this.error || this.submitButton.removeAttribute("aria-disabled"), this.querySelector(".loading-overlay__spinner").classList.add("hidden"), freeShippMsg()
        })
    }
    handleErrorMessage(t = !1) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".pform-error-wrap"), this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".pform-error-msg"), this.errorMessageWrapper.toggleAttribute("hidden", !t), t && (this.errorMessage.textContent = t))
    }
}), freeShippMsg();

document.getElementById('toggle-description').addEventListener('click', function () {
    const container = document.querySelector('.collection-description');
    container.style.maxHeight = 'none';
    this.style.display = 'none';
});
